import { useState, useEffect } from 'react';
import { TBillingFreeCreditItem, TGetPaymentBillingFreeCreditList } from 'types/financials';
import { getPaymentBillingFreeCreditList, getPaymentBillingPracticeFreeCreditList } from 'api/financials';

const usePaymentBillingFreeCreditList = (
    param?: Partial<TGetPaymentBillingFreeCreditList>,
    isPractice = false,
): [
    TBillingFreeCreditItem[] | undefined,
    number,
    boolean,
    (param?: Partial<TGetPaymentBillingFreeCreditList>) => void,
] => {
    const [data, setData] = useState<TBillingFreeCreditItem[]>();
    const [total, setTotal] = useState<number>(0);
    const [loading, setLoading] = useState<boolean>(false);

    const fetchData = async (para: Partial<TGetPaymentBillingFreeCreditList> = {}) => {
        try {
            setLoading(true);
            const request = isPractice ? getPaymentBillingPracticeFreeCreditList : getPaymentBillingFreeCreditList;
            const res = await request({
                current: 1,
                size: 10,
                ...para,
            });
            if (!res.error) {
                const list = res.data?.data?.records || [];
                const amount = res.data?.data?.total;
                setTotal(amount || 0);
                setData(list);
            }
        } catch (err) {
            console.error('Payment list fetch error:', err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData(param);
    }, []);

    return [data, total, loading, fetchData];
};

export default usePaymentBillingFreeCreditList;
